import { getViewData, setComponentData } from '../../core/views';
import { EDITOR_VIEW_NAME, SHARE_MODAL_STATE, SHARE_PROJECT_STATE } from '../../core/constants';
import { translate } from '../../core/i18n';

import { ShareButton } from '../share/ShareButton';
import { ShareInfo } from '../share/ShareInfo';
import { ShareStatus } from '../share/ShareStatus';
import { getDomainCfg, store } from '../../core/state';
import { BaseModal } from './BaseModal';
import { setProjectToPrivate, setProjectToPublic } from '../../core/code/saver';
import { buildPublicUrl, CLOUD_USER } from '../../features/cloudstorage/cloud';
import { showLoginRegisterModal } from './LoginRegisterModal';
import { resetDismissedLogin } from '../../features/login';
import { cloudProjectId } from '../../core/project/projectid';
import { logGamificationEvent } from '../../features/gamification/events';

export const showShareModal = () : void => {
  setComponentData(SHARE_MODAL_STATE, { data : { show : true }});
}

export const hideShareModal = () : void => {
  setComponentData(SHARE_MODAL_STATE, { data : { show : false }});
}

export const isShareButtonVisible = () : boolean => {
  if (getDomainCfg().viewSettings.features.showShareButton !== true) return false;  
  if (getDomainCfg().viewSettings.features.shareCondition === "none") return false;
  if (getDomainCfg().viewSettings.features.shareCondition === "project") {
    const editorState = getViewData(EDITOR_VIEW_NAME);
    return (editorState.project.shareable === true);
  }
  return true;
}

export const ShareModal = () => {
  const [cloudUser] = store.useState(CLOUD_USER);
  const [shareProjectState, setShareProjectState] = store.useState(SHARE_PROJECT_STATE);
  const [modalState, setModalState] = store.useState(SHARE_MODAL_STATE);

  if (!modalState?.data) {
    setModalState({ data : { show : false }});
    return null;
  }

  const shareButtonClicked = async () : Promise<void> => {
    if (!cloudUser.loggedIn) {
      console.log("not logged in, try login!")
      resetDismissedLogin();
      showLoginRegisterModal(true);
      return;
    }
    if (shareProjectState?.sharingStatus === "private") {
      //publishProject and get url
      const url = buildPublicUrl(await cloudProjectId());
      setProjectToPublic(url);
      logGamificationEvent("ProjectShared", "URL:" + url, "");
    } else if (shareProjectState?.sharingStatus === "public") {
      setProjectToPrivate();
    }
  }

  if (!shareProjectState || !shareProjectState.sharingStatus) {
    // check if project shareable
    const newShareProjectState = {
      sharingStatus : "private",
      url : ""
    }
    setShareProjectState(newShareProjectState);
  }

  const modalBody = (<>
    <ShareStatus shareState={shareProjectState} />
    <ShareButton shareState={shareProjectState} clicked={shareButtonClicked} />
    <ShareInfo shareState={shareProjectState} loggedIn={cloudUser.loggedIn} shown={modalState.data.show} />
  </>);

  return (<BaseModal title={translate("share-project")}
    childBody={modalBody}
    show= {modalState.data.show}
    handleClose={hideShareModal}
    size={"lg"}
     />);
};
